import classnames from 'classnames'
import React from 'react'
import { Text } from '../Text'
import { IProps } from './index'
import { getThemeProps } from './themes'
import checkmark from '../../images/checkmark.svg'
import checkmarkWhite from '../../images/checkmark-white.svg'
import bulletPoint from '../../images/bullet-point.svg'

export const CheckMarks = (props: IProps): React.ReactElement => {
  const { items, vertical, large, inverse, alternateItemIcon, headline, theme } = props
  const containerClassNames = classnames('list-container', theme)
  const checkMarksClassNames = classnames('checkmarks', {
    white: inverse === true,
    vertical,
    large,
  })

  const iconClassname = classnames('checkmarks-icon', alternateItemIcon)
  const themeProps = getThemeProps(props)

  return (
    <div className={containerClassNames}>
      {headline && (
        <span className="headline">
          <Text brand="default" size="eyebrows">
            {headline}
          </Text>
        </span>
      )}
      <ul className={checkMarksClassNames}>
        {items.map((item) => {
          return (
            <li key={item} className="checkmarks-item">
              <span className={iconClassname} />
              <Text brand="default" size={themeProps.listTextSize}>
                {item}
              </Text>
            </li>
          )
        })}
      </ul>
      <style jsx>{`
        // Default theme
        .list-container {
          display: grid;
        }

        .headline {
          text-transform: uppercase;
          padding-bottom: 13px;
        }

        .checkmarks {
          list-style: none;
          flex-direction: row;
        }

        .checkmarks-item {
          display: inline-block;
          margin-right: 12px;

          &:last-child {
            margin-right: 0;
          }
        }

        .checkmarks-icon {
          display: inline-block;
          height: 12px;
          width: 12px;
          margin-right: 4px;
          background: url(${checkmark}) no-repeat;
          background-size: 100%;

          &.bullet-point {
            background: url(${bulletPoint}) no-repeat;
          }
        }

        .checkmarks.vertical .checkmarks-item {
          width: 100%;
        }

        .checkmarks.large .checkmarks-icon {
          height: 20px;
          width: 20px;
          margin-right: 1.5em;
        }

        .checkmarks.white {
          .checkmarks-item {
            color: $white;
          }

          .checkmarks-icon {
            background: url(${checkmarkWhite}) no-repeat;
          }
        }

        @include media-query(tablet) {
          .checkmarks {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
          }

          .checkmarks-item {
            margin-right: 25px;
            margin-bottom: 6px;

            &:last-child {
              margin-right: 0;
            }
          }
        }

        // Inbound theme
        .list-container.inbound {
          .checkmarks {
            margin-left: 10px;
          }
        }
      `}</style>
    </div>
  )
}
